import React, { FunctionComponent } from 'react';
import type { TvDetail } from '../../../types/tvShow';
import { Loading } from '../../atoms/loading';
import { TvShowTop } from '../../organisms/tvShowTop';
import { TvShowBody } from '../../organisms/tvShowBody';
import { RelatedTvList } from '../../organisms/relatedTvList';

type Props = {
  tv: TvDetail | null;
  currentUser: boolean;
  lineIcon: string;
};

export const Presentation: FunctionComponent<Props> = ({
  tv,
  currentUser,
  lineIcon,
}) => {
  if (!tv) return <div className="applicants-loading blur is-active"><Loading /></div>;

  return (
    <main className="l-wrap l-wrap-single l-wrap-old js-background-fixed">
      {/* 上部エリア（YouTube + タイトルなど） */}
      <TvShowTop tv={tv} currentUser={currentUser} lineIcon={lineIcon} />
      {/* 詳細エリア（本文 + ボタン） */}
      <TvShowBody tv={tv} />
      {/* 関連動画 */}
      <RelatedTvList tvId={tv.id} />
    </main>
  );
};
